import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const siteMultiUpdateActionTypes = {
  PATCH: type('[site multi] Patch'),
  PATCH_SUCCESS: type('[site multi] Patch Success'),
  PATCH_FAIL: type('[site multi] Patch Fail'),
};

export class PatchSitesMultiAction implements Action {
  readonly type = siteMultiUpdateActionTypes.PATCH;
  // tslint:disable-next-line:no-any
  constructor(public payload?: { api: string[], data: any}) {}
}

export class PatchSitesMultiSuccessAction implements Action {
  readonly type = siteMultiUpdateActionTypes.PATCH_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: {response: any, path: string}) {}
}

export class PatchSitesMultiFailAction implements Action {
  readonly type = siteMultiUpdateActionTypes.PATCH_FAIL;
  constructor(public payload?: string) {}
}
